import React from "react";
import cx from "classnames";

import "./TOC.scss";

const sectionIndexRegex = /^(?<path>(?:L?\d+\.)*\d+):\s+(?<name>.+)/;

const TOC = ({ tableOfContents, depth = 1, lastDepth = '', highlight = null }) => {
    return (
        <ol className={`toc toc--depth-${depth}`}>
            {
                tableOfContents.items.map((heading, i) => {
                    const customIndex = sectionIndexRegex.exec(heading.title.trim());
                    const index = customIndex ? customIndex.groups.path : `${lastDepth}${i + 1}`;
                    const title = customIndex ? customIndex.groups.name : heading.title;

                    return (
                        <li key={i}>
                            <a href={heading.url} className={cx('toc__entry', {
                                'toc__entry--highlight': highlight && heading.url && highlight === heading.url.substring(1)
                            })}>
                            <span className="toc__index">{`${index} `}</span>
                            <span className="toc__name">{title}</span>
                        </a>
                            {heading.items && <TOC
                                tableOfContents={heading}
                                depth={depth + 1}
                                lastDepth={`${lastDepth}${i + 1}.`}
                                highlight={highlight} />}
                        </li>
                    );
                })
            }
        </ol>
    );
};

export default TOC
